import React from 'react';
import { Button } from 'react-bootstrap';
import { useAuth } from '../../AuthContext';
import { useNavigate } from 'react-router-dom';
import '../../styles/components/user/Logout.css';
import Popup from '../common/popup/Popup';

const Logout = ({ show, handleClose }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      handleClose();
      navigate('/');
    } catch (error) {
      console.error('Logout Error:', error);
    }
  };

  if (!show) return null;

  return (
    <Popup
      title="Log Out"
      onCancel={handleClose}
      className="popup-modal logout-modal"
      footer={
        <>
          <Button variant="danger" onClick={handleLogout}>Logout</Button>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
        </>
      }
    >
      <p>Are you sure you want to log out of your account?</p>
    </Popup>
  );
};

export default Logout;
